export const GET_ACADEMIC_CYCLE_CONFIGS = "GET_ACADEMIC_CYCLE_CONFIGS"
export const GET_ACADEMIC_CYCLE_CONFIGS_FAIL = "GET_ACADEMIC_CYCLE_CONFIGS_FAIL"
export const GET_ACADEMIC_CYCLE_CONFIGS_SUCCESS = "GET_ACADEMIC_CYCLE_CONFIGS_SUCCESS"

export const ADD_NEW_ACADEMIC_CYCLE_CONFIG = "ADD_NEW_ACADEMIC_CYCLE_CONFIG"
export const ADD_ACADEMIC_CYCLE_CONFIG_SUCCESS = "ADD_ACADEMIC_CYCLE_CONFIG_SUCCESS"
export const ADD_ACADEMIC_CYCLE_CONFIG_FAIL = "ADD_ACADEMIC_CYCLE_CONFIG_FAIL"

export const UPDATE_ACADEMIC_CYCLE_CONFIG = "UPDATE_ACADEMIC_CYCLE_CONFIG"
export const UPDATE_ACADEMIC_CYCLE_CONFIG_SUCCESS = "UPDATE_ACADEMIC_CYCLE_CONFIG_SUCCESS"
export const UPDATE_ACADEMIC_CYCLE_CONFIG_FAIL = "UPDATE_ACADEMIC_CYCLE_CONFIG_FAIL"

export const DELETE_ACADEMIC_CYCLE_CONFIG = "DELETE_ACADEMIC_CYCLE_CONFIG"
export const DELETE_ACADEMIC_CYCLE_CONFIG_SUCCESS = "DELETE_ACADEMIC_CYCLE_CONFIG_SUCCESS"
export const DELETE_ACADEMIC_CYCLE_CONFIG_FAIL = "DELETE_ACADEMIC_CYCLE_CONFIG_FAIL"





